
import React, {useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {getDeliveryPercentList, getGoogleSheet, getMyPrediction, getSymbolList } from "../action/api-services";
import StockAction from "../component/stockAction";
import moment from "moment";
import { useDispatch } from "react-redux";
import PageLoader from "../component/loader";
import DeliveryGraph from "../component/deliveryGraph";
import { setDeliveryDateReducer } from "../redux/slice/deliveryDate";
import { useNavigate } from "react-router-dom";
import { AIPromptForStock1, NSE_filter_volume } from "../utils/constants";
import SectorPanchang from "../component/sectorPanchag";
import { degAngle } from "../utils/utilsFunctions";



const GoldenStocksPage2 = () => {
    const dispatch = useDispatch();
    const [loader, setLoader] = useState(false);
    const [symbolData, setSymbolData] = useState([]);
    const [todayData, setTodayData] = useState([]);
    const [todayDate, setTodayDate] = useState([]);
    // const [startDate, setStartDate] = useState(new Date());
    const [series, setSeries] = useState('EQ');
    const [startDate, setStartDate] = useState('2025-09-23');
    const [predictionData, setPredictionData] = useState([]);
    const [getGoldenStocks, setGoldenStocks] = useState([]);
    const [deliveryDataList, setDeliveryDataList] = useState([]);
    const userToken = useSelector((state) => state.userToken.value);
    const navigate = useNavigate();
    
    
    

    useEffect(() => {  
        if(userToken){
            let current_date = moment(startDate).format('DDMMYY');
            dispatch(setDeliveryDateReducer(startDate));      
            
            getDeliveryPercentList(current_date, '', '', '', 'EQ', '', userToken).then(function (response) {    
                setDeliveryDataList(response.data.data);
            }).catch(function (err) {console.log("Error", err) });

            
            getSymbolList(series, '', userToken).then(function (response) {
                setSymbolData(response.data.data);
            }).catch(function (err) {console.log("Error", err) });

            getMyPrediction(current_date, userToken).then(function (response) {
                setPredictionData(response.data.data);
            }).catch(function (err) {console.log("Error", err) });

            getGoogleSheet(current_date, userToken).then(function (response) {
                setTodayData(response.data.data.json_data);
                setTodayDate(response.data.data.datetime);
            }).catch(function (err) {console.log("Error", err) }); 
        }else{
            navigate(`/`);
        }

    }, [startDate]);


    useEffect(() =>{
        setLoader(false);
        


        if(deliveryDataList && todayData && symbolData && predictionData){

            const currentFilteredData = deliveryDataList?.map((item) =>{
                let currentStocks = [];

                const ltpIndex = todayData?.findIndex(a => a.TICKER === item.symbol);
                const ltpStock = todayData[ltpIndex];

                const deliveryStock = item['stock_data'];
                const lastDeliveryDate = deliveryStock[0]['delivery_date'];

                
                // console.log(ltpStock['CHANGEPER'])

                const isNewDay = ltpIndex !== -1 && ltpStock?.DATETIME !== '#N/A' && !moment(ltpStock?.DATETIME).isSame(lastDeliveryDate, "day");
                if(isNewDay){                    
                    let todayPrice = {
                        "avg_price":   parseFloat(deliveryStock[0]['avg_price']),
                        "chn_per": ltpStock['CHANGEPER'] !==  '#N/A'? parseFloat(ltpStock['CHANGEPER']): 0,
                        "low_price": ltpStock['LOW'] !==  '#N/A'? parseFloat(ltpStock['LOW']): 0,
                        "open_price": ltpStock['OPEN'] !==  '#N/A'? parseFloat(ltpStock['OPEN']): 0,
                        "high_price": ltpStock['HIGH'] !==  '#N/A'? parseFloat(ltpStock['HIGH']): 0,
                        "close_price": ltpStock['LTP'] !==  '#N/A'? parseFloat(ltpStock['LTP']): 0,
                        "prev_close": parseFloat(deliveryStock[0]['close_price']),
                        "ttl_trd_qty": ltpStock['VOLUME'] !==  '#N/A'? parseInt(ltpStock['VOLUME']): 0,
                        "delivery_qty": parseInt(deliveryStock[0]['delivery_qty']),
                        "delivery_per": parseFloat(deliveryStock[0]['delivery_per']),
                        "delivery_date": moment(ltpStock['DATETIME']).format('YYYY-MM-DD')
                    }
                    currentStocks = [todayPrice, ...deliveryStock];
                }else{
                    currentStocks = deliveryStock;
                }
                currentStocks = deliveryStock;
                const match = symbolData.find(s => s.symbol === item.symbol);
                const prediction = predictionData.find(p => p.symbol === item.symbol)
                return {
                        ...item,
                        stock_data: currentStocks,
                        details: match,
                        prediction: prediction,
                    }; 

            }).filter(item => {
                
                const stockData = item['stock_data'];
                if (stockData.length <= 1) {
                    return false; 
                }

                const { min, max } = (stockData.slice(1, stockData.length) || []).reduce((acc, item) => {
                    const raw = item?.ttl_trd_qty;
                    if (raw == null) return acc;
                    const v = Number(String(raw).replace(/,/g, '').trim());
                    if (!Number.isFinite(v)) return acc;

                    if (acc.min === null || v < acc.min) acc.min = v;
                    if (acc.max === null || v > acc.max) acc.max = v;
                    return acc;
                }, { min: null, max: null });

                // console.log(min, max);
                
                const avgVolumes = Math.round( stockData.slice(1).reduce((sum, val) => {
                    const qty = Number(String(val?.ttl_trd_qty || "0").replace(/,/g, ""));
                    return sum + qty;
                }, 0) / (stockData.length - 1));
                                
                const todayPrice = stockData[0]['close_price'];
                const todayChnPer = stockData[0]['chn_per'];
                const todayVolume = parseInt(stockData[0]['ttl_trd_qty'])
                const todayPrevVol = parseInt(stockData[1]['ttl_trd_qty']);
                const todayPrevDiff = Math.round((todayVolume - todayPrevVol) * 100 / todayPrevVol);
                    

                // console.log(item.symbol, avgVolumes, max)

                const match = symbolData.find(s => s.symbol === item.symbol && s.active === '1' && s.series === 'EQ'
                    && parseInt(s.MarketCap) > 1000 
                    && todayPrice > parseFloat(s.DMA20) 
                    && parseFloat(s.DMA20) > parseFloat(s.DMA50) 
                    && parseFloat(s.DMA50) > parseFloat(s.DMA200)
                    );
                return match && stockData[0]['ttl_trd_qty'] > max && stockData[0]['ttl_trd_qty'] > avgVolumes && avgVolumes > NSE_filter_volume 
                    && todayPrevDiff > 125 
                    && todayChnPer > 0
            })
            console.log(currentFilteredData);

            setGoldenStocks(currentFilteredData);
            setLoader(true);

        }

    },[deliveryDataList, predictionData, symbolData])

    

return (
    <React.Fragment>
        <div className="pageContainer">
        {
            (loader === false? <PageLoader />: 
            <div className="pagewrap fullheight">
                <table className="increaseOI">
                    <thead>
                        <tr key="item_0_0">
                            {/* <th style={{width:'120px'}}>Date</th> */}
                            <th style={{width:'120px'}}>Symbol</th>
                            <th style={{width:'45px'}}></th>
                            <th style={{width:'20px'}}>&nbsp;</th>
                            <th style={{width:'110px', textAlign:'left'}}>Sector</th>
                            <th style={{width:'55px', textAlign:'left'}}>Indices</th>
                            <th style={{width:'55px', textAlign:'left'}}>Trends</th>
                            <th style={{width:'70px'}}>Break Price</th>
                            <th style={{width:'50px'}}>Chn%</th> 
                            <th style={{width:'60px'}}>LTP</th>                            
                            <th style={{width:'50px'}}>L Chn%</th> 
                            <th style={{width:'50px'}}>T Chn%</th> 
                            <th style={{width:'50px'}}>14 Days</th>
                            <th style={{width:'150px'}}>14 | 9 | 5 Deg&deg;</th>
                            <th style={{width:'45px'}}>RSI</th>
                            <th style={{width:'45px'}}>ADX</th>
                            <th style={{width:'60px'}}>52 Down</th>
                            <th style={{width:'115px'}}>52 L/H</th>
                            <th style={{width:'75px'}}>AT Vol</th>
                            <th style={{width:'120px'}}>Curr Vol</th>
                            <th style={{width:'50px'}}>Del%</th>
                            <th style={{width:'25px'}}>News</th>
                        </tr>
                    </thead>
                    <tbody>
                    
                    {getGoldenStocks?.map((item, index) =>{
                            let symbolName = item.symbol;
                            let todayLTP = todayData?.find((item, index) => item.TICKER === symbolName);
                            let angle_5 = degAngle(item.prediction?.price_5, todayLTP?.LTP, 5);
                            let angle_9 = degAngle(item.prediction?.price_9, todayLTP?.LTP, 9);
                            let angle_14 = degAngle(item.prediction?.price_14, todayLTP?.LTP, 14);
                            let prevVolume = (((parseInt(todayLTP?.VOLUME) - parseInt(item.prediction?.ttl_trd_qty)) * 100) / parseInt(item.prediction?.ttl_trd_qty)).toFixed(2);

                            return(
                                <tr className={`tr_${item.details?.id}`} key={`item_0_4_${index}`}>
                                {/* <td style={{lineHeight:1.1}}>{moment(item.datetime).format('DD-MM-YY HH:mm A')}</td> */}
                                <td className="symbolName" style={{background: parseFloat(item.prediction?.delivery_per) > 40 && item.prediction?.sma_angle_5 > 1 && todayLTP?.VOLUME > item.prediction?.ttl_trd_qty? '#cde9d7':null}}>
                                    {symbolName} 
                                    {moment(new Date()).isSame(moment(item.breakout_date), 'day') ? (item.occurance > 1 ? `(${item.occurance})` : item.similar_count > 1 ? `(${item.similar_count})` : '') : ''}
                                    {item.details.hotStar === '1'? <span className="hotStar"></span>:null}
                                </td>
                               <td style={{textAlign:'left'}}><DeliveryGraph symbol={symbolName} todayLTP={todayLTP}/></td>
                                <td><StockAction symbol={symbolName} delivery={false} currentPrice ={todayLTP?.LTP} deliveryPer={item.prediction?.delivery_per} hotStar={item.details.hotStar} myFev={item.details.myFev} eventName = "NR7" /></td>
                                <SectorPanchang sector={item.details?.group_sector} />
                                <td className="indices" style={{ textAlign: 'left' }}>
                                        {(() => {
                                                const label = item.details.nifty50? '50': item.details.nifty100? '100': item.details.nifty200? '200': item.details.nifty500? '500': item.details.totalMarket? 'TM': '';
                                                const excludedSeries = ['ETF', 'BOND', 'MF'];
                                                const showFev = item.details.myFev && !excludedSeries.includes(item.details.series);
                                                return label + (showFev ? `${label ? ', ' : ''}Fev` : '');
                                        })()}
                                </td>                
                                <td style={{textAlign:"left"}}></td>
                                <td>{item['stock_data'][1].close_price}</td>
                                <td style={{color:parseFloat(todayLTP?.CHANGEPER) > 0? "#1c8b16":"#f00"}}>{parseFloat(todayLTP?.CHANGEPER)}%</td>
                                <td>{parseFloat(todayLTP?.LTP).toFixed(2)}</td>
                                <td style={{color: todayLTP?.CHANGEPER > 0 ? '#1c8b16' : '#f00'}}>{todayLTP?.CHANGEPER}%</td>                               
                                <td>{(((todayLTP?.LTP - item['stock_data'][1].close_price) * 100)/item['stock_data'][1].close_price).toFixed(2)}%</td>
                                
                                <td>{parseFloat(item.prediction?.price_14_date_PL).toFixed(2)}%</td>

                                <td style={{textAlign:'right', backgroundColor: (parseFloat(angle_5) > parseFloat(angle_9)) && (parseFloat(angle_9) > parseFloat(angle_14))? '#e9ffe3':''}}>
                                    {angle_14}&deg; | {angle_9}&deg; | {angle_5}&deg;
                                </td>
                                <td>{parseFloat(item.prediction?.rsi).toFixed(2)}</td>
                                <td>{parseFloat(item.prediction?.adx).toFixed(2)}</td>
                                <td style={{textAlign:'right'}}>{item.details.high52w? ((item.details.high52w - todayLTP?.LTP)*100/item.details.high52w).toFixed(2): ''}%</td>
                                <td title={`${moment(item.details.lowDate).format('DD-MM-YY')} / ${moment(item.details.highDate).format('DD-MM-YY')}`}>{item.details.low52w}{item.details? '/':''}{item.details.high52w}</td>

                                <td style={{backgroundColor: parseInt(todayLTP?.VOLUME) > parseInt(item.prediction?.ttl_trd_qty)? '#cde9d7':''}} title={ parseInt(item.prediction?.ttl_trd_qty)?.toLocaleString('en-IN')}>{parseInt(todayLTP?.VOLUME)?.toLocaleString('en-IN')}</td>
                                <td>{prevVolume}%</td>
                                <td style={{backgroundColor: item.prediction?.delivery_spike === "Delivery Spike" && prevVolume > 100? '#cde9d7':''}}>{item.prediction?.delivery_per}%</td>
                                <td><a className="newsicon" 
                                        // href={`https://www.google.com/search?q=why+${symbolName}+share+breakout+${moment(item['stock_data'][0].delivery_date).format('Do MMMM YYYY')}`} 
                                        href={`https://www.google.com/ai?q=${AIPromptForStock1(symbolName)}`}
                                        target="_blank"></a></td>
                            </tr>
                            )
                    })}
                    
                    </tbody>
                </table>
            </div>
            )
        }
        </div>
    </React.Fragment>
)

}
export default GoldenStocksPage2;